import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EmployeeCareerProgramService } from '../employee-career-program.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { startWith } from 'rxjs/operators';
import { forEach } from 'jszip';
import { TeamDetailsModel } from 'src/app/Models/TeamDetailsModel';
import { MatTableDataSource } from '@angular/material/table';
import { ModularConfirmDialogComponent } from 'src/app/views/field-missing-employees/components/modular-confirm-dialog/modular-confirm-dialog.component';
import { MatPaginator } from '@angular/material/paginator';

export interface User {
  employeeName: string,
  userId: string
  searchText: string
}
@Component({
  selector: 'app-assign-programs-dialog',
  templateUrl: './assign-programs-dialog.component.html',
  styleUrls: ['./assign-programs-dialog.component.css']
})
export class AssignProgramDialogComponent {
  form = new FormGroup({
    selectedUsers: new FormControl(null, [Validators.required])
  });

  userId: Number;
  employeeId: Number;
  programName: string;
  from: number = 0;
  size: number = 5;
  totalRecords: number = 0;
  public dataSource: MatTableDataSource<any>;
  teamDetails: any;
  displayedColumns = ["select", "employeeId", "employeeName", "email", "status"];
  searchText: string = '';
  selection = new Set<number>();
  filterStatus: any[] = [
    { id: 0, label: 'New', checked: false },
    { id: 1, label: 'In Progress', checked: false },
    { id: 2, label: 'Completed', checked: false },
    { id: 3, label: 'Not Started', checked: false }
  ];
  selectedStatusIds: number[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  constructor(private dialogRef: MatDialogRef<AssignProgramDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public programData: any,
    private service: EmployeeCareerProgramService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private toast: ToastrService) {
    this.programName = this.programData.programName;
  }

  ngOnInit(): void {
    this.employeeId = parseInt(localStorage.getItem("Id"));
    this.userId = parseInt(localStorage.getItem('EmpCareerUserID'));
    this.getTeamDetails();
    this.dataSource = new MatTableDataSource();
  }

  applyFilter() {
    this.from = 0;
    this.getTeamDetails();
    this.resetPagination();
  }

  AssignUsers() {
    const action = "assign"
    const entity = "program"
    if (this.selection.size === 0) {
      this.toast.error("Please select at least one employee to assign");
    }
    else {
      const dialogRef = this.dialog.open(ModularConfirmDialogComponent, {
        width: '493px',
        height: '240px',
        data: { action, entity }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          const selectedUserIds = Array.from(this.selection);
          if (!selectedUserIds.length) {
            return;
          }

          this.service.assignPrograms({
            programIds: [this.programData.programID],
            userIds: selectedUserIds
          }).subscribe(() => {
            this.form.reset();
            this.toast.success("Assigned Successfully");
            setTimeout(() => this.dialogRef.close(), 500);
          }, () => {
            this.toast.error("Try again");
            setTimeout(() => this.dialogRef.close(), 500);
          });
        }
      })
    }
  }

  getTeamDetails() {
    const model: TeamDetailsModel = {
      EmployeeId: this.employeeId.toString(),
      ProgramId: this.programData.programID,
      From: this.from,
      Size: this.size,
      searchText: this.searchText.toString(),
      StatusIds: this.selectedStatusIds
    }
    this.service.getTeamDetails(model).subscribe((res) => {
      this.teamDetails = res.items;
      this.totalRecords = res.total;
      this.dataSource = new MatTableDataSource<any>(this.teamDetails);
      console.log(this.dataSource);
    })
  }

  getPaginatorData(event) {
    this.size = event.pageSize;
    this.from = event.pageIndex * this.size;
    this.getTeamDetails();
  }

  toggleSelection(row: any) {
    if (this.selection.has(row.userId)) {
      this.selection.delete(row.userId);
    } else {
      this.selection.add(row.userId);
    }
  }

  toggleAllRows(event: any) {
    const visibleRows = this.dataSource.data.filter(row => !this.isCheckboxDisabled(row));
    if (event.checked) {
      visibleRows.forEach(row => this.selection.add(row.userId));
    } else {
      visibleRows.forEach(row => this.selection.delete(row.userId));
    }
  }

  isSelected(row: any): boolean {
    return this.selection.has(row.userId);
  }

  isAllSelected(): boolean {
    const visibleRows = this.dataSource.data.filter(row => !this.isCheckboxDisabled(row));
    return visibleRows.length > 0 && visibleRows.every(row => this.selection.has(row.userId));
  }

  isIndeterminate(): boolean {
    const visibleRows = this.dataSource.data.filter(row => !this.isCheckboxDisabled(row));
    const selectedVisibleRows = visibleRows.filter(row => this.selection.has(row.userId));
    return selectedVisibleRows.length > 0 && selectedVisibleRows.length < visibleRows.length;
  }

  onCancel() {
    this.selection.clear();
    this.dialogRef.close();
  }

  clearStatusFilter() {
    this.filterStatus.forEach(option => option.checked = false);
    this.selectedStatusIds = [];
    this.getTeamDetails();
  }

  applyStatusFilter() {
    this.selectedStatusIds = this.filterStatus
      .filter(option => option.checked)
      .map(option => option.id);

    this.resetPagination();
    this.getTeamDetails();
    
  }

  isCheckboxDisabled(row: any): boolean {
    const status = row.status?.toLowerCase();
    return status === 'not started' || status === 'in progress';
  }

  hasSelectableRows(): boolean {
    return this.dataSource?.data?.some(row => !this.isCheckboxDisabled(row));
  }

  resetPagination() {
    this.from = 0;
    this.size = 5;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginator._changePageSize(this.size);
    }
  }

}
